/**
 * 主題顏色設定
 */
import { UrlPlatform } from '@/utils/platform';
import { useEffect, useCallback } from 'react';
import { useDispatch } from 'umi';

/**
 * @param {object} query location.query
 */
const useTheme = (query) => {
  const dispatch = useDispatch();

  /**
   * 设置深色模式
   * @param {boolean} status
   */
  const setIsDark = useCallback(
    (status: boolean) => {
      dispatch({ type: 'public/update', payload: { isDark: !!status }});
      if (status) {
        document.querySelector('body')?.classList.add('theme-dark');
      } else {
        document.querySelector('body')?.classList.remove('theme-dark');
      }
    },
    [dispatch],
  );

  /**
   * 设置主色
   * @param {boolean} status
   */
  const setBrand = useCallback(
    (platform: UrlPlatform) => {
      if (platform === UrlPlatform.business) {
        dispatch({ type: 'public/update', payload: { platform, brandColor: 'blue' }});
        document.querySelector('body')?.classList.add('theme-blue');
        document.querySelector('body')?.classList.remove('theme-green');
      } else {
        dispatch({ type: 'public/update', payload: { platform, brandColor: 'green' }});
        document.querySelector('body')?.classList.add('theme-green');
        document.querySelector('body')?.classList.remove('theme-blue');
      }
    },
    [dispatch],
  );

  useEffect(() => {
    const { isDark } = query;
    if (isDark === 'true') {
      setIsDark(true);
    } else if (isDark === 'false') {
      setIsDark(false);
    }
  }, [query, setIsDark]);

  useEffect(() => {
    const { platform } = query;
    setBrand(platform);
  }, [query, setBrand]);
};

export default useTheme;
